import React, { Component } from "react";
import "../../styles/storyIQ/footer.scss";
import translations from "../../translations/footer.json";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

class StoryIQFooter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			utmQueries: "utm_source=sertifier&utm_medium=cpc",
			email: "",
			startTimestamp: null,
			isSubmitted: false,
		};
		this.props.addTranslation(translations);
	}

	componentDidMount() {
		this.setState({ startTimestamp: Math.floor(Date.now() / 1000) });
	}

	handleEmailChange = (e) => {
		this.setState({ email: e.target.value });
	};

	handleSubmit = async (e) => {
		e.preventDefault();

		const formData = new FormData();
		formData.append("wpforms[fields][1]", this.state.email);
		formData.append("wpforms[id]", "157");
		formData.append("page_title", "Homepage");
		formData.append("page_url", window.location.href);
		formData.append("page_id", "318634");
		formData.append("wpforms[post_id]", "318634");
		formData.append("wpforms[submit]", "wpforms-submit");
		formData.append("wpforms[token]", "adef1ff9b23e80e5271e3d8eb7b4f523");
		formData.append("action", "wpforms_submit");
		formData.append("start_timestamp", this.state.startTimestamp.toString());
		formData.append("end_timestamp", Math.floor(Date.now() / 1000).toString());

		try {
			const response = await fetch(
				"https://storyiq.com/wp-admin/admin-ajax.php",
				{
					method: "POST",
					body: formData,
					headers: {
						Accept: "application/json, text/javascript, */*; q=0.01",
						"X-Requested-With": "XMLHttpRequest",
					},
					credentials: "include",
				}
			);

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			// Set submission success state
			this.setState({ isSubmitted: true, email: "" });
		} catch (error) {
			console.error("Error submitting form:", error);
		}
	};

	renderForm() {
		return (
			<div className="input-container">
				<div className="signup-form">
					<div className="wpforms-container" id="wpforms-157">
						<form
							id="wpforms-form-157"
							className="wpforms-validate wpforms-form wpforms-ajax-form"
							onSubmit={this.handleSubmit}
							noValidate
						>
							<div className="wpforms-field-container flex-row w-100">
								<div
									id="wpforms-157-field_1-container"
									className="wpforms-field wpforms-field-email"
									data-field-id="1"
								>
									<input
										type="email"
										id="wpforms-157-field_1"
										className="wpforms-field-medium wpforms-field-required form-control"
										name="wpforms[fields][1]"
										placeholder="Email address"
										value={this.state.email}
										onChange={this.handleEmailChange}
										spellCheck="false"
										required
									/>
								</div>
								<div className="wpforms-submit-container wpforms-one-third">
									<button
										type="submit"
										id="wpforms-submit-157"
										className="wpforms-submit"
										data-alt-text="Sending..."
										data-submit-text="Submit"
										aria-live="assertive"
									>
										<Translate id="signMeUp" />
									</button>
									<img
										src="https://storyiq.com/wp-content/plugins/wpforms/assets/images/submit-spin.svg"
										className="wpforms-submit-spinner"
										style={{ display: "none" }}
										width="26"
										height="26"
										alt="Loading"
									/>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div id="story-footer-main" className="flex-column">
				<section className="signup text-white w-100">
					<div className="container-xl">
						<div className="container-inner flex-row ai-c w-100">
							<div className="signup-text">
								<h5 className="mb-lg-0">
									<Translate id="signUpText" />
								</h5>
							</div>
							{this.state.isSubmitted ? (
								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "flex-end",
									}}
									className="success-message"
								>
									<h5 className="mb-lg-0">Thanks for signing up!</h5>
								</div>
							) : (
								this.renderForm()
							)}
						</div>
					</div>
				</section>
				<div className="flex-column info-container">
					<div className="flex-row bottom-part">
						<div className="flex-column ai-fs contact-us">
							<div className="logo-container flex-row ai-c">
								<a href="https://storyiq.com/" target="_self">
									<img
										alt="storyIQ"
										className="main-icon"
										src={
											require(`../../assets/storyIQ/storyIQ-footer-icon.svg`)
												.default
										}
									/>
								</a>
								<span className="desc-text">
									<Translate id="footerDescText" />
								</span>
							</div>
							<hr />
							<div className="flex-column w-100 ai-fs">
								<h6 className="title bold">
									<Translate id="contactUs" />
								</h6>
								<address className="address-text">
									<p>30 West 21st Street</p>
									<p>7th Floor, New York, NY</p>
									<p>United States 10010</p>
								</address>
								<div className="flex-row jc-sb w-100">
									<div className="contact-detail">
										P <a href="tel:1 (718) 801 8556">+1 718 801 8556</a>
									</div>
									<div className="contact-detail">
										E <a href="mailto:info@storyiq.com">info@storyiq.com</a>
									</div>
								</div>
							</div>
							<div className="flex-row socials">
								<a href="https://www.facebook.com/StoryIQLtd" target="_blank">
									<img
										alt="storyIQ"
										className="main-icon"
										src="https://storyiq.com/wp-content/uploads/2022/05/icon-facebook.svg"
									></img>
								</a>
								<a href="https://x.com/StoryIQHQ" target="_blank">
									<img
										alt="storyIQ"
										className="main-icon"
										src="https://storyiq.com/wp-content/uploads/2024/11/twitter-x-xxl.png"
									></img>
								</a>
								<a
									href="https://www.linkedin.com/company/storyiq/"
									target="_blank"
								>
									<img
										alt="storyIQ"
										className="main-icon"
										src="https://storyiq.com/wp-content/uploads/2022/05/Linked-In.svg"
									></img>
								</a>
								<a href="https://www.instagram.com/storyiqhq" target="_blank">
									<img
										alt="storyIQ"
										className="main-icon"
										src="https://storyiq.com/wp-content/uploads/2022/05/Instagram.svg"
									></img>
								</a>
							</div>
							<hr className="socials-line-break" />
						</div>
						<ul className="footer__menu footer__menu--main row">
							<li className="menu-item menu-item-type-custom menu-item-object-custom">
								<div className="column-item">
									<a
										href="https://storyiq.com/explore-our-courses/"
										target="_self"
									>
										<Translate id="courses" />
									</a>
									<ul className="sub-menu">
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/course/data-storytelling-for-business/"
												target="_self"
											>
												<Translate id="dataStoryBusiness" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/course/data-literacy-for-everyone/"
												target="_self"
											>
												<Translate id="dataLiteracy" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/course/data-to-insights/"
												target="_self"
											>
												<Translate id="dataToInsights" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/course/presenting-with-impact/"
												target="_self"
											>
												<Translate id="presWithImpact" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/course/designing-effective-dashboards/"
												target="_self"
											>
												<Translate id="designingDashboards" />
											</a>
										</li>
									</ul>
								</div>
								<div className="column-item">
									<a href="#" target="_self">
										<Translate id="topics" />
									</a>
									<ul className="sub-menu">
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/data-storytelling/"
												target="_self"
											>
												<Translate id="dataStory" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/data-storytelling/"
												target="_self"
											>
												<Translate id="datavisualization" />
											</a>
										</li>
									</ul>
								</div>
							</li>
							<li className="menu-item menu-item-type-custom menu-item-object-custom">
								<div className="column-item">
									<a href="https://storyiq.com/locations/" target="_self">
										<Translate id="locations" />
									</a>
									<ul className="sub-menu">
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/united-states/"
												target="_self"
											>
												United States
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/australia/"
												target="_self"
											>
												Australia
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/indonesia/"
												target="_self"
											>
												Indonesia
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/malaysia/"
												target="_self"
											>
												Malaysia
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/philippines/"
												target="_self"
											>
												Philippines
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/singapore/"
												target="_self"
											>
												Singapore
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/locations/united-kingdom/"
												target="_self"
											>
												United Kingdom
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a href="https://storyiq.com/contact-us/" target="_self">
												<Translate id="allLocations" />
											</a>
										</li>
									</ul>
								</div>
							</li>
							<li className="menu-item menu-item-type-custom menu-item-object-custom">
								<div className="column-item">
									<a href="https://storyiq.com/our-story/" target="_self">
										<Translate id="about" />
									</a>
									<ul className="sub-menu">
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a href="https://storyiq.com/our-story/" target="_self">
												<Translate id="ourStory" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/facilitators/"
												target="_self"
											>
												<Translate id="ourInst" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/our-story/#ourleadership"
												target="_self"
											>
												<Translate id="ourLeadership" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/for-companies/#testimonials"
												target="_self"
											>
												<Translate id="testimonials" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a href="https://storyiq.com/careers/" target="_self">
												<Translate id="careers" />
											</a>
										</li>
									</ul>
								</div>
							</li>
							<li className="menu-item menu-item-type-custom menu-item-object-custom">
								<div className="column-item">
									<a href="https://storyiq.com/resources/" target="_self">
										<Translate id="resources" />
									</a>
									<ul className="sub-menu">
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/data-story-action-book/"
												target="_self"
											>
												<Translate id="storytellingBook" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/data-story-action-book/"
												target="_self"
											>
												<Translate id="bookResources" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/our-tedx-and-keynote-talks/"
												target="_self"
											>
												<Translate id="tedx" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a
												href="https://storyiq.com/webinars-and-videos/"
												target="_self"
											>
												<Translate id="webinars" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a href="https://storyiq.com/resources/" target="_self">
												<Translate id="guides" />
											</a>
										</li>
										<li className="menu-item menu-item-type-post_type menu-item-object-post menu-item-has-children">
											<a href="https://storyiq.com/blog/" target="_self">
												Blog
											</a>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
					<hr />
					<div className="footer__bottom flex-row w-100">
						<div className="footer__legals">
							<span>
								<Translate id="copyright" />
							</span>
						</div>
						<div className="footer__terms flex-row jc-fe">
							<a href="https://storyiq.com/privacy-policy/" target="_self">
								<Translate id="privacyPolicy" />
							</a>
							<a href="https://storyiq.com/terms/" target="_self">
								<Translate id="terms" />
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withLocalize(StoryIQFooter);
